/* Paws & Paths -- Liquid Scroll System. Mirrors the Tactile Air store's motion language: buttery reveal-on-scroll, a scroll-progress indicator, and a cursor-reactive hero glow/parallax. Degrades silently when prefers-reduced-motion is set or on touch devices. */
(function () {
"use strict";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function ready(fn) {
if (document.readyState !== "loading") fn();
else document.addEventListener("DOMContentLoaded", fn);
}
function matchAccentColor() {
try {
var sample = document.querySelector(".button:not(.button--secondary), button[type='submit'], a.button, .btn-primary");
if (!sample) sample = document.querySelector(".button, .btn");
if (sample) {
var bg = getComputedStyle(sample).backgroundColor;
if (bg && !/rgba?\(0,\s*0,\s*0,\s*0\)/.test(bg) && bg !== "transparent") {
document.documentElement.style.setProperty("--pp-liquid-accent", bg);
}
}
} catch (e) {}
}
function initProgressBar() {
var bar = document.createElement("div");
bar.className = "pp-progress";
var span = document.createElement("span");
bar.appendChild(span);
document.body.appendChild(bar);
var ticking = false;
function update() {
var top = window.scrollY || document.documentElement.scrollTop;
var max = document.documentElement.scrollHeight - window.innerHeight;
var pct = max > 0 ? Math.min(100, Math.max(0, (top / max) * 100)) : 0;
span.style.width = pct + "%";
ticking = false;
}
window.addEventListener("scroll", function () {
if (!ticking) {
requestAnimationFrame(update);
ticking = true;
}
}, { passive: true });
update();
}
function initReveal() {
var selectors = [
"main .shopify-section .product-card",
"main .shopify-section .collection-card",
"main .shopify-section .card-wrapper",
"main .shopify-section .rich-text",
"main .shopify-section .banner__content",
"main .shopify-section .grid__item",
"main .shopify-section > .page-width > *"
];
var els = new Set();
selectors.forEach(function (sel) {
document.querySelectorAll(sel).forEach(function (el) {
if (el.closest("header, footer, [data-pp-skip]")) return;
els.add(el);
});
});
if (els.size < 3) {
        document.querySelectorAll("main .shopify-section").forEach(function (section) {
            if (section.closest("header, footer")) return;
                var tall = section.offsetHeight > window.innerHeight * 1.15;
                    var kids = tall ? Array.prototype.slice.call(section.children).filter(function (c) { return c.offsetHeight > 0; }) : [];
                        if (kids.length >= 1) { kids.forEach(function (k) { els.add(k); }); } else { els.add(section); }
                            });
}
var byParent = new Map();
els.forEach(function (el) {
el.classList.add("pp-reveal");
var p = el.parentElement;
if (!byParent.has(p)) byParent.set(p, []);
byParent.get(p).push(el);
});
byParent.forEach(function (list) {
list.forEach(function (el, i) {
el.style.setProperty("--pp-i", Math.min(i, 6));
});
});
if (!("IntersectionObserver" in window)) {
els.forEach(function (el) { el.classList.add("pp-visible"); });
return;
}
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) {
entry.target.classList.add("pp-visible");
io.unobserve(entry.target);
}
});
}, { threshold: 0.14, rootMargin: "0px 0px -7% 0px" });
els.forEach(function (el) { io.observe(el); });
setTimeout(function () { els.forEach(function (el) { el.classList.add("pp-visible"); }); if (io && io.disconnect) io.disconnect(); }, 1200);
}
function initHeroGlow() {
if (!window.matchMedia("(any-pointer: fine)").matches) return;
var hero = document.querySelector("[data-pp-hero]") || document.querySelector("main .shopify-section:first-of-type .banner, main .shopify-section:first-of-type .slideshow");
if (!hero) return;
hero.classList.add("pp-hero-glow", "pp-glow-active");
var frame = null;
hero.addEventListener("pointermove", function (event) {
if (frame) cancelAnimationFrame(frame);
frame = requestAnimationFrame(function () {
var bounds = hero.getBoundingClientRect();
var x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
var y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
hero.style.setProperty("--pp-pointer-x", x * 100 + "%");
hero.style.setProperty("--pp-pointer-y", y * 100 + "%");
var shiftX = (x - 0.5) * -14;
var shiftY = (y - 0.5) * -14;
hero.querySelectorAll("[data-pp-parallax]").forEach(function (el) {
el.style.setProperty("--pp-shift-x", shiftX + "px");
el.style.setProperty("--pp-shift-y", shiftY + "px");
});
});
});
hero.addEventListener("pointerleave", function () {
hero.style.setProperty("--pp-pointer-x", "70%");
hero.style.setProperty("--pp-pointer-y", "30%");
hero.querySelectorAll("[data-pp-parallax]").forEach(function (el) {
el.style.setProperty("--pp-shift-x", "0px");
el.style.setProperty("--pp-shift-y", "0px");
});
});
}
ready(function () {
matchAccentColor();
if (reduceMotion) return;
initProgressBar();
initReveal();
initHeroGlow();
});
})();
